/* eslint-disable no-useless-escape */
const getUrlParameter = (name) => {
  if (typeof window === 'undefined' || typeof location === 'undefined') return null
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

const updateQueryStringParam = (key, value) => {
  let baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
    urlQueryString = document.location.search,
    newParam = key + '=' + value,
    params = '?' + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    const updateRegex = new RegExp('([\?&])' + key + '[^&]*');
    const removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

    if ( typeof value === 'undefined' || value === null || value === '' || value === '0') { // Remove param if value is empty
      params = urlQueryString.replace(removeRegex, '$1');
      params = params.replace( /[&;]$/, '' );

    } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
      params = urlQueryString.replace(updateRegex, '$1' + newParam);

    } else { // Otherwise, add it to end of query string
      params = urlQueryString + '&' + newParam;
    }
  }
  // no parameter was set so we don't need the question mark
  params = params === '?' ? '' : params;

  window.history.replaceState({}, '', baseUrl + params);
};

const replaceSpecialCharacters = (str, replacement='') => {
  let string = str?.replaceAll(/[^a-zA-Z0-9-_æøåÆØÅeEéÉåäöÅÄÖ. ]/g, replacement);
  string.replace(/\. $/, '');
  return string.trim()
}

export { getUrlParameter, updateQueryStringParam, replaceSpecialCharacters };
